import React from 'react';

export const RouterContext = React
  .createContext
  /* optional default value */
  ();
